import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const DirectorForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [directorName, setDirectorName] = useState("");
  const [loading, setLoading] = useState(false);
  const [originalDirectorName, setOriginalDirectorName] = useState("");

  useEffect(() => {
    if (id) {
      setLoading(true);
      supabase
        .from("directors")
        .select("directors")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            // alert("Failed to load director");
            Swal.fire({
              position: "top-end", // top-right corner
              icon: "error", // success, error, warning, info
              title: "Failed to load director", // your message
              showConfirmButton: false, // no OK button
              timer: 3000, // auto close after 3 seconds
              timerProgressBar: true, // shows a progress bar
              toast: true, // makes it a toast
              background: "white", // optional, Tailwind prefers light bg
              customClass: {
                popup: "shadow-lg rounded-md p-3", // Tailwind classes
              },
            });
            navigate("/directors");
          } else {
            // setDirectorName(data.directors);
            setDirectorName(data.directors);
            setOriginalDirectorName(data.directors.trim().toLowerCase());

          }
          setLoading(false);
        });
    }
  }, [id, navigate]);

  const handleSave = async (e) => {

    e.preventDefault();

    if (!directorName.trim()) {
      //   alert("Please enter a director name");
      Swal.fire({
        position: "top-end", // top-right corner
        icon: "warning", // success, error, warning, info
        title: "Please enter a director name", // your message
        showConfirmButton: false, // no OK button
        timer: 3000, // auto close after 3 seconds
        timerProgressBar: true, // shows a progress bar
        toast: true, // makes it a toast
        background: "white", // optional, Tailwind prefers light bg
        customClass: {
          popup: "shadow-lg rounded-md p-3", // Tailwind classes
        },
      });
      return;
    }

    setLoading(true);


    const normalized = directorName.trim().toLowerCase();

    // ✅ ADD MODE — strict duplicate check
    if (!id) {
      const { data: existing } = await supabase
        .from("directors")
        .select("id")
        .eq("directors", directorName.trim());

      if (existing && existing.length > 0) {
        setLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `"${directorName}" already exists`,
          showConfirmButton: false,
          timer: 3000,
          toast: true,
        });
        return;
      }
    }

    // ✅ EDIT MODE — only check if name changed
    if (id) {
      if (normalized !== originalDirectorName) {
        const { data: existing } = await supabase
          .from("directors")
          .select("id")
          .eq("directors", directorName.trim())
          .neq("id", id); // 🔑 exclude self

        if (existing && existing.length > 0) {
          setLoading(false);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `"${directorName}" already exists`,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
          return;
        }
      }
    }



    if (id) {
      // Update existing director
      const { error } = await supabase
        .from("directors")
        .update({ directors: directorName.trim() })
        .eq("id", id);
      setLoading(false);

      if (error) {
        // alert("Failed to update director");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "error", // success, error, warning, info
          title: "Failed to update director", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        // alert("Director updated successfully");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Director updated successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
        navigate("/directors");
      }
    } else {
      // Insert new director
      const { error } = await supabase
        .from("directors")
        .insert([{ directors: directorName.trim() }]);
      setLoading(false);

      if (error) {
        // alert("Failed to add director");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "error", // success, error, warning, info
          title: "Failed to add director", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        // alert("Director added successfully");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Director added successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
        navigate("/directors");
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => navigate(-1)}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border border-gray-300 rounded-md p-8 shadow-md"
        >
          <h1 className="text-3xl font-bold text-center text-gray-800">
            {id ? "Edit Director" : "Add Director"}
          </h1>

          <div>
            <label
              htmlFor="directorName"
              className="block mb-2 font-semibold text-gray-700"
            >
              Enter director name
            </label>
            <input
              id="directorName"
              name="directorName"
              type="text"
              value={directorName}
              onChange={(e) => setDirectorName(e.target.value)}
              placeholder="Enter director name"
              autoFocus
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            />
          </div>

          <div className="flex justify-center gap-4">
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold text-lg"
            >
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate("/directors")}
              className="px-8 py-3 font-semibold text-lg"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DirectorForm;
